import React from "react";

const sections = [
  {
    title: "State Government – Bihar",
    links: [
      { name: "Government of Bihar", url: "https://state.bihar.gov.in" },
      { name: "Chief Minister Office, Bihar", url: "https://cm.bihar.gov.in" },
      { name: "Governor of Bihar", url: "https://governor.bihar.gov.in" },
      { name: "Finance Department, Bihar", url: "https://finance.bihar.gov.in" },
      { name: "Home Department, Bihar", url: "https://home.bihar.gov.in" },
    ],
  },
  {
    title: "Judiciary – Bihar",
    links: [
      { name: "Patna High Court", url: "https://patnahighcourt.gov.in" },
      { name: "District Courts of Bihar (eCourts)", url: "https://districts.ecourts.gov.in/bihar" },
      { name: "Bihar Judicial Services", url: "https://bjsc.bihar.gov.in" },
    ],
  },
  {
    title: "Legislature – Bihar",
    links: [
      { name: "Bihar Legislative Assembly", url: "https://vidhansabha.bih.nic.in" },
      { name: "Bihar Legislative Council", url: "https://vidhanparishad.bih.nic.in" },
    ],
  },
  {
    title: "Constitutional & Statutory Bodies – Bihar",
    links: [
      { name: "Bihar State Election Commission", url: "https://sec.bihar.gov.in" },
      { name: "Bihar Public Service Commission (BPSC)", url: "https://www.bpsc.bih.nic.in" },
      { name: "Bihar State Vigilance Commission", url: "https://vigilance.bihar.gov.in" },
      { name: "Bihar Human Rights Commission", url: "https://bhrc.bihar.gov.in" },
    ],
  },
  {
    title: "Law, Compliance & Public Services – Bihar",
    links: [
      { name: "Right to Public Services, Bihar", url: "https://serviceonline.bihar.gov.in" },
      { name: "Bihar Police", url: "https://police.bihar.gov.in" },
      { name: "Bihar Land Records", url: "https://biharbhumi.bihar.gov.in" },
      { name: "e-District Bihar", url: "https://edistrict.bihar.gov.in" },
    ],
  },
  {
    title: "Local Government Bodies – Bihar",
    links: [
      { name: "Urban Local Bodies (ULB Bihar)", url: "https://urban.bihar.gov.in" },
      { name: "Panchayati Raj Department, Bihar", url: "https://ps.bihar.gov.in" },
    ],
  },
  {
    title: "National Links",
    links: [
      { name: "National Portal of India", url: "https://www.india.gov.in" },
      { name: "Election Commission of India", url: "https://eci.gov.in" },
      { name: "NITI Aayog", url: "https://www.niti.gov.in" },
      { name: "Lok Sabha", url: "https://loksabha.nic.in" },
      { name: "Rajya Sabha", url: "https://rajyasabha.nic.in" },      
      { name: "Supreme Court of India", url: "https://www.sci.gov.in" },      
      { name: "Income Tax Department", url: "https://www.incometax.gov.in" },
      { name: "GST Portal", url: "https://www.gst.gov.in" },
      { name: "MCA", url: "https://www.mca.gov.in" },
      { name: "DigiLocker", url: "https://www.digilocker.gov.in" },   

    ],
  },
];


export default function IndiaCivicIndex() {
  return (
    <div className="min-h-screen bg-black text-white px-4 py-6">
        <div className="bg-gradient-to-r from-orange-500 via-white to-green-600 px-4 py-4">
            <h1 className="text-xl md:text-2xl font-semibold text-center text-black">
                Think5Whys BCI – Bihar Civic Index
            </h1>
            <p className="text-sm md:text-base font-medium text-center text-black/80">
                Official Government Portals
            </p>
        </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-1 mt-2 mb-2">
        {sections.map((section, index) => (
          <div
            key={index}
            className="border border-blue-400 rounded-md p-4"
          >
            <h2 className="text-lg lg:text-lg font-medium mb-1 text-blue-400">
              {section.title}
            </h2>

            <ul className="space-y-2">
              {section.links.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-sm text-white/80 hover:text-white underline underline-offset-4"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
        <div className="bg-gradient-to-r from-orange-500 via-white to-green-600 px-4 py-4">
            <p className="text-xs lg:text-sm font-semibold text-center text-black">
                (c) 2026 - Think5Whys Global DeepTech Solutions, Mumbai, Maharashtra, India
            </p>
            <p className="text-xs lg:text-sm text-center text-black/80">
                Disclaimer: This Index is aggregation of civic links and is presenetd for information purpose only.
            </p>
        </div>      
    </div>
  );
}
